import PropTypes from 'prop-types';

export const TaskComplianceIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={'custom-icon ' + className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12704 7.2002H5.32911C5.03422 7.2002 4.80005 7.4498 4.80005 7.76412V8.61463C4.80005 8.92895 5.03422 9.17855 5.32911 9.17855H6.12704C6.42192 9.17855 6.6561 8.92895 6.6561 8.61463V7.76412C6.6561 7.4498 6.42192 7.2002 6.12704 7.2002ZM6.16173 8.62387C6.16173 8.62387 6.14438 8.66085 6.12704 8.66085L5.29442 8.62387L5.32911 7.73639L6.16173 7.77336V8.62387Z"
        fill="#113E57"
      />
      <path
        d="M13.1266 7.7915H7.41965C7.252 7.7915 7.11609 7.93637 7.11609 8.11507V8.28147C7.11609 8.46017 7.252 8.60503 7.41965 8.60503H13.1266C13.2942 8.60503 13.4301 8.46017 13.4301 8.28147V8.11507C13.4301 7.93637 13.2942 7.7915 13.1266 7.7915Z"
        fill="#113E57"
      />
      <path
        d="M13.1266 10.417H7.41965C7.252 10.417 7.11609 10.5619 7.11609 10.7406V10.907C7.11609 11.0857 7.252 11.2305 7.41965 11.2305H13.1266C13.2942 11.2305 13.4301 11.0857 13.4301 10.907V10.7406C13.4301 10.5619 13.2942 10.417 13.1266 10.417Z"
        fill="#113E57"
      />
      <path
        d="M13.0483 13.0708H7.3414C7.17375 13.0708 7.03784 13.2157 7.03784 13.3944V13.5608C7.03784 13.7395 7.17375 13.8843 7.3414 13.8843H13.0483C13.216 13.8843 13.3519 13.7395 13.3519 13.5608V13.3944C13.3519 13.2157 13.216 13.0708 13.0483 13.0708Z"
        fill="#113E57"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12704 9.84521H5.32911C5.03422 9.84521 4.80005 10.0948 4.80005 10.4091V11.2596C4.80005 11.574 5.03422 11.8236 5.32911 11.8236H6.12704C6.42192 11.8236 6.6561 11.574 6.6561 11.2596V10.4091C6.6561 10.0948 6.42192 9.84521 6.12704 9.84521ZM6.16173 11.2596C6.16173 11.2596 6.14438 11.2966 6.12704 11.2966L5.29442 11.2596L5.32911 10.3722L6.16173 10.4091V11.2596Z"
        fill="#113E57"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12704 12.4785H5.32911C5.03422 12.4785 4.80005 12.7281 4.80005 13.0424V13.8929C4.80005 14.2073 5.03422 14.4569 5.32911 14.4569H6.12704C6.42192 14.4569 6.6561 14.2073 6.6561 13.8929V13.0424C6.6561 12.7281 6.42192 12.4785 6.12704 12.4785ZM6.16173 13.8929C6.16173 13.8929 6.14438 13.9299 6.12704 13.9299L5.29442 13.8929L5.32911 13.0055L6.16173 13.0424V13.8929Z"
        fill="#113E57"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3555 3.50344C15.8189 3.50344 16.2096 3.64948 16.5366 3.94158H16.5094C16.8365 4.23368 17 4.58591 17 4.99828V15.4021C17 16.2869 16.2459 17 15.3101 17H3.67171C3.20836 17 2.81769 16.854 2.49061 16.5619C2.16354 16.2698 2 15.9175 2 15.5052V4.99828C2 4.58591 2.16354 4.23368 2.49061 3.94158C2.81769 3.64948 3.21744 3.50344 3.67171 3.50344H4.50757V2.79038C4.50757 2.35223 4.88007 2 5.34343 2C5.80678 2 6.17929 2.35223 6.17929 2.79038V3.50344H7.2877V2.79038C7.2877 2.35223 7.66021 2 8.12356 2C8.58692 2 8.95942 2.35223 8.95942 2.79038V3.50344H10.0678V2.79038C10.0678 2.35223 10.4403 2 10.9037 2C11.3671 2 11.7396 2.35223 11.7396 2.79038V3.50344H12.848V2.79038C12.848 2.35223 13.2205 2 13.6838 2C14.1472 2 14.5197 2.35223 14.5197 2.79038V3.50344H15.3555ZM3.68988 15.5052H15.3737V4.99828H14.5379V5.59966C14.5379 6.0378 14.1654 6.39003 13.702 6.39003C13.2386 6.39003 12.8661 6.0378 12.8661 5.59966V4.99828H11.7577V5.59966C11.7577 6.0378 11.3852 6.39003 10.9219 6.39003C10.4585 6.39003 10.086 6.0378 10.086 5.59966V4.99828H8.97759V5.59966C8.97759 6.0378 8.60509 6.39003 8.14173 6.39003C7.67838 6.39003 7.30588 6.0378 7.30588 5.59966V4.99828H6.19746V5.59966C6.19746 6.0378 5.82495 6.39003 5.3616 6.39003C4.89824 6.39003 4.52574 6.0378 4.52574 5.59966V4.99828H3.68988V15.5052Z"
        fill="#113E57"
      />
    </svg>
  );
};

TaskComplianceIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
